const MarketPaymentTool = {
  getVirtualAccount(price) {
    const now = new Date();
    const time = `${now.getTime()}`;
    const paymentViewId = `${time.substring(time.length - 5, time.length)}`;
    return this.getMarketPaymentCode(paymentViewId, price);
  },
  getBarCode1(price) {
    // let bankCode = '6R7';//上勇收款代號
    // let bankCode = '6R8'; // 嘉好收款代號 即將註銷
    // if (parseInt(price, 10) <= 20000) {
    //   bankCode = '6R8';
    // } else if (parseInt(price, 10) > 20000 && parseInt(price, 10) <= 40000) {
    //   bankCode = 'AU5';
    // } else if (parseInt(price, 10) > 40000 && parseInt(price, 10) <= 60000) {
    //   bankCode = '6RZ';
    // }
    let bankCode = '6R5'; // 嘉好收款代號
    if (parseInt(price, 10) <= 20000) {
      bankCode = '6R5';
    } else if (parseInt(price, 10) > 20000 && parseInt(price, 10) <= 40000) {
      bankCode = 'AU4';
    } else if (parseInt(price, 10) > 40000 && parseInt(price, 10) <= 60000) {
      bankCode = '6RY';
    }
    // const customCode = `49${MM < 10? '0'+MM : MM}${DD < 10? '0'+DD : DD}${bankCode}`;
    const customCode = `491231${bankCode}`;
    return customCode;
  },
  // 虛擬帳號
  getMarketPaymentCode(customCode, price) {
    const eAccountCode = '7735'; // 上勇
    // const eAccountCode = '5839'; // 嘉好 即將註銷
    const MMDD = '1231';
    const defaultCode = `${eAccountCode}${MMDD}${customCode}`;

    const secretCode = [4, 5, 6, 7, 8, 9, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let code = 0;
    [...defaultCode].forEach((s, i) => {
      const count = parseInt(s, 10) * secretCode[i];
      // console.log(`count： ${s} x ${secretCode[i]} = ${count}`);
      code += parseInt(count.toString().split('').pop(), 10);
    });
    // console.log(`code text： ${code}`);
    const firstCode = parseInt(code.toString().split('').pop(), 10);
    const firstCodeResult = 10 - firstCode;
    console.log(`第一段檢核碼 firstCode：10 - ${firstCode} = ${firstCodeResult}`);

    const secondCode = `${price}`.padStart(8, '0');
    console.log(`金額 ${price}`);
    const secondSecretCode = [8, 7, 6, 5, 4, 3, 2, 1];
    let secondCodeResult = 0;
    [...secondCode].forEach((s, i) => {
      const count = parseInt(s, 10) * secondSecretCode[i];
      // console.log(`count： ${s} x ${secondSecretCode[i]} = ${count}`);
      secondCodeResult += parseInt(count.toString().split('').pop(), 10);
    });
    // console.log(`secondCodeResult： ${secondCodeResult}`);
    const secondCheckCode = parseInt(secondCodeResult.toString().split('').pop(), 10);
    const secondCheckCode2 = (10 - secondCheckCode);
    const secondCheckCodeResult = secondCheckCode2.toString().split('').pop();
    console.log(`第二段檢核碼 secondCode： 10 - ${secondCheckCode} = ${secondCheckCode2} 取個位數 ${secondCheckCodeResult}`);

    let checkCode = parseInt(firstCodeResult, 10) + parseInt(secondCheckCodeResult, 10);
    console.log(`金額檢核碼1 ： ${checkCode}`);
    if (checkCode >= 10) {
      checkCode = checkCode.toString().split('').pop();
    }
    console.log(`金額檢核碼2 ： ${checkCode}`);
    const result = `${defaultCode}${checkCode}`;
    console.log(`虛擬帳號 ： ${result}`);
    return result;
  },
  // 交易檢查碼
  getMarketCheckCode(barCode1, barCode2, barCode3) {
    const barCode1Odd = this.getBarCodeNumber(barCode1, true);
    const barCode2Odd = this.getBarCodeNumber(barCode2, true);
    const barCode3Odd = this.getBarCodeNumber(barCode3, true);
    console.log(`barCode1 === ${barCode1Odd} ${barCode2Odd} ${barCode3Odd}`);
    let firstCode = (parseInt(barCode1Odd, 10) + parseInt(barCode2Odd, 10)
      + parseInt(barCode3Odd, 10)) % 11;
    if (firstCode === 0) {
      firstCode = 'A';
    }
    if (firstCode === 10) {
      firstCode = 'B';
    }

    const barCode1Result = this.getBarCodeNumber(barCode1, false);
    const barCode2Result = this.getBarCodeNumber(barCode2, false);
    const barCode3Result = this.getBarCodeNumber(barCode3, false);
    console.log(`barCode2 === ${barCode1Result} ${barCode2Result} ${barCode3Result}`);
    let secondCode = (parseInt(barCode1Result, 10) + parseInt(barCode2Result, 10)
      + parseInt(barCode3Result, 10)) % 11;
    if (secondCode === 0) {
      secondCode = 'X';
    }
    if (secondCode === 10) {
      secondCode = 'Y';
    }
    const result = `${firstCode}${secondCode}`;
    console.log(`BarCode 檢查碼 === ${result}`);
    return result;
  },
  getBarCodeNumber(barCode, isOdd) {
    const mapKeys = { A: 1,
      B: 2,
      C: 3,
      D: 4,
      E: 5,
      F: 6,
      G: 7,
      H: 8,
      I: 9,
      J: 1,
      K: 2,
      L: 3,
      M: 4,
      N: 5,
      O: 6,
      P: 7,
      Q: 8,
      R: 9,
      S: 2,
      T: 3,
      U: 4,
      V: 5,
      W: 6,
      X: 7,
      Y: 8,
      Z: 9,
      '+': 1,
      '%': 2,
      '-': 6,
      '.': 2,
      '': 8,
      $: 2,
      '/': 0 };

    const array = [...barCode.toUpperCase()].map((text) => {
      // console.log(`mapKeys === ${mapKeys[text]}`);
      if (mapKeys[text]) {
        return mapKeys[text];
      }
      return text;
    });
    // console.log(`array === ${array}`);
    let barCodeNumber = 0;
    array.forEach((n, i) => {
      if (isOdd) {
        if (i % 2 === 0) {
          barCodeNumber += parseInt(n, 10);
        }
      } else if (i % 2 !== 0) {
        barCodeNumber += parseInt(n, 10);
      }
    });
    // console.log(`barCodeNumber === ${barCodeNumber}`);
    return barCodeNumber;
  },
  getBarCode3(barCode1, barCode2, price) {
    // const now = new Date();
    // const MM = now.getMonth()+1;
    // const DD = now.getDate();
    // const dateCode = `${MM < 10? '0'+MM : MM}${DD < 10? '0'+DD : DD}`;
    const dateCode = '1231';
    const priceCode = price.toString().padStart(9, '0');
    const code3 = `${dateCode}${priceCode}`;
    console.log(`金額 ${price}`);
    // console.log(`code3 === ${code3}`);
    const checkCode = this.getMarketCheckCode(barCode1.split('*').join(''), barCode2.split('*').join(''), code3);
    return `${dateCode}${checkCode}${priceCode}`;
  },
};

export default MarketPaymentTool;



// WEBPACK FOOTER //
// ./src/utils/MarketPaymentTool.js